import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { STOCK } from "../lib/config";

// Add new posts to this array; the first is rendered as the featured story.
const NEWS = [
  {
    id: "oc-gop-endorsement-2026",
    featured: true,
    tags: ["Endorsement", "Campaign"],
    source: "Finger Lakes Daily News",
    date: "January 27, 2026",
    headline:
      "Ontario County Republican Committee Endorses Jeff Trickler for County Treasurer",
    summary:
      "The Ontario County Republican Committee has endorsed Jeff Trickler for reelection as County Treasurer, announced following its January 22 meeting in Hopewell. Committee Chairwoman Trisha Turner said the party is proud to support incumbents who have represented residents with dedication and integrity. Trickler, the incumbent county treasurer, previously served as deputy treasurer and as Chief of Police for the City of Geneva.",
    url: "https://www.fingerlakesdailynews.com/local/hopewell-ny/ontario-county-republican-committee-announces-endorsements/",
    image: STOCK.government,
  },
];

export default function News() {
  const featured = NEWS.find((n) => n.featured) || NEWS[0];

  return (
    <div data-testid="news-page">
      <PageHero
        eyebrow="Newsroom"
        title="Campaign news &amp; updates"
        intro="The latest endorsements, announcements, and coverage from the reelection campaign."
        testid="news-hero"
      />

      <section className="py-20 md:py-28 bg-background">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <Reveal>
            <p className="text-sm uppercase tracking-overline font-bold text-red-700 mb-8">
              Featured Story
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <article
              data-testid="featured-article"
              className="grid lg:grid-cols-2 bg-white border border-slate-200 rounded-sm overflow-hidden"
            >
              <div className="relative min-h-[280px] lg:min-h-full overflow-hidden">
                <img
                  src={featured.image}
                  alt={featured.headline}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[hsl(var(--navy))]/20" />
              </div>

              <div className="p-8 md:p-12 flex flex-col">
                <div className="flex flex-wrap items-center gap-2 mb-5">
                  {featured.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs uppercase tracking-widest font-bold text-red-700 bg-red-50 px-3 py-1 rounded-sm"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="flex items-center gap-2 text-sm text-slate-500 mb-4">
                  <span className="font-semibold text-slate-700">{featured.source}</span>
                  <span>&middot;</span>
                  <span>{featured.date}</span>
                </div>

                <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-[hsl(var(--navy))] leading-tight">
                  {featured.headline}
                </h2>

                <p className="mt-5 text-slate-600 leading-relaxed flex-1">{featured.summary}</p>

                <a
                  href={featured.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="read-full-article-btn"
                  className="focus-ring group mt-8 inline-flex items-center gap-2 self-start bg-[hsl(var(--navy))] text-white font-semibold px-7 py-3.5 rounded-sm hover:bg-red-700 transition-colors"
                >
                  Read Full Article
                  <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </div>
            </article>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-16 text-center border-t border-dashed border-slate-300 pt-12">
              <p className="font-display text-2xl md:text-3xl text-slate-500 italic" data-testid="more-updates-note">
                More updates coming soon.
              </p>
              <p className="mt-3 text-sm text-slate-400">
                Check back as the campaign shares new endorsements and announcements.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
